import { useCustomMutation } from '@devd-client/devd/components';
import * as ENDPOINTS from './endpoints';

export const QUERY_KEYS = {
  updatePullDays: 'updatePullDays',
  updateSubscriptionPlan: 'updateSubscriptionPlan',
  updateEnabledModules: 'updateEnabledModules',
  setIntegrationInactive: 'setIntegrationInactive',
  resetAccountState: 'resetAccountState',
  deactivateAllActiveIntegrations: 'deactivateAllActiveIntegrations',
  reactivateIntegrations: 'reactivateIntegrations',
};

export const useUpdatePullDays = () => {
  return useCustomMutation(
    [QUERY_KEYS.updatePullDays],
    ENDPOINTS.updatePullDays
  );
};

export const useUpdateSubscriptionPlan = () => {
  return useCustomMutation(
    [QUERY_KEYS.updateSubscriptionPlan],
    ENDPOINTS.updateSubscriptionPlan
  );
};

export const useUpdateEnabledModules = () => {
  return useCustomMutation(
    [QUERY_KEYS.updateEnabledModules],
    ENDPOINTS.updateEnabledModules
  );
};

export const useSetIntegrationInactive = () => {
  return useCustomMutation(
    [QUERY_KEYS.setIntegrationInactive],
    ENDPOINTS.setIntegrationInactive
  );
};

export const useResetAccountState = () => {
  return useCustomMutation(
    [QUERY_KEYS.resetAccountState],
    ENDPOINTS.resetAccountState
  );
};

export const useDeactivateAllActiveIntegrations = () => {
  return useCustomMutation(
    [QUERY_KEYS.deactivateAllActiveIntegrations],
    ENDPOINTS.deactivateAllActiveIntegrations
  );
};

export const useReactivateIntegrations = () => {
  return useCustomMutation(
    [QUERY_KEYS.reactivateIntegrations],
    ENDPOINTS.reactivateIntegrations
  );
};
